import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, Grid, IconButton, Rating, TextField, Typography } from '@mui/material';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createRatingReply } from '../../../../core/ratings/actions';

const CustomIconButton = styled(IconButton)`
  &.MuiIconButton-root {
    background-color: rgba(9, 151, 186, 0.14);
    color: #0997ba;
    transition: 250ms;

    &:hover {
      background-color: rgba(9, 151, 186, 0.3);
    }
  }
`;

function RatingCard({ rating }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);

  const { comment, score, reviewer, replies } = rating;
  const [reply, setReply] = useState();

  const handleSubmit = () => {
    if (!reply?.trim()) return;

    const newReply = {
      comment: reply,
      rating: { id: rating.id },
      user: { id: user.id },
    };

    dispatch(createRatingReply(newReply));
    setReply(undefined);
  };

  return (
    <Card>
      <CardContent>
        <Grid container>
          <Grid item xs={12} display="flex" alignItems="center" columnGap={2}>
            <Rating value={score} disabled />
            <Typography variant="body2" color="#999" marginTop={4} margin={0}>
              By {`${reviewer.name} ${reviewer.last_name}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" marginTop={4} my={2}>
              {comment}
            </Typography>
          </Grid>
          <Grid item xs={11} pl={4}>
            <TextField
              value={replies?.length ? replies[0].comment : reply}
              onChange={(e) => setReply(e.target.value)}
              multiline
              fullWidth
              placeholder="Reply..."
              disabled={replies?.length > 0}
            />
          </Grid>
          <Grid item xs={1} textAlign="center">
            <CustomIconButton onClick={handleSubmit} disabled={replies?.length > 0}>
              <SendOutlinedIcon sx={{ pl: 0.5 }} />
            </CustomIconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

RatingCard.propTypes = {
  rating: PropTypes.shape({
    id: PropTypes.number.isRequired,
    comment: PropTypes.string.isRequired,
    score: PropTypes.number.isRequired,
    reviewer: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
    }).isRequired,
    replies: PropTypes.arrayOf(
      PropTypes.shape({
        comment: PropTypes.string.isRequired,
      }).isRequired,
    ),
  }).isRequired,
};

export default RatingCard;
